import React, { useState } from 'react';
import { Card, List, Tag, Space, Typography, Button, Popconfirm, message } from 'antd';
import { blogPosts, deleteBlogPost } from '../../api/mockData';
import { Link } from 'react-router-dom';
import { DeleteOutlined } from '@ant-design/icons';
import './index.css';

const { Title } = Typography;

const ArchivePage = () => {
  const [posts, setPosts] = useState(blogPosts);

  const handleDelete = (postId) => {
    const success = deleteBlogPost(postId);
    if (success) {
      // 更新本地状态以反映删除
      setPosts(prev => prev.filter(post => post.id !== postId));
      message.success('文章删除成功！');
    } else {
      message.error('删除文章失败！');
    }
  };

  return (
    <div className="archive-container">
      <Card className="archive-header" title="文章归档" extra="所有文章列表" />
      
      <Card className="archive-card">
        <List
          dataSource={posts}
          renderItem={post => (
            <List.Item key={post.id}>
              <List.Item.Meta
                title={
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Link to={`/post/${post.id}`}>
                      <Title level={4} style={{ marginBottom: 8 }}>{post.title}</Title>
                    </Link>
                    <Popconfirm 
                      title="确认删除" 
                      description="您确定要删除这篇文章吗？此操作不可恢复。" 
                      onConfirm={() => handleDelete(post.id)}
                      okText="是" 
                      cancelText="否"
                    >
                      <Button 
                        type="text" 
                        danger 
                        icon={<DeleteOutlined />} 
                        style={{ marginLeft: '10px' }}
                      >
                        删除
                      </Button>
                    </Popconfirm>
                  </div>
                }
                description={
                  <Space size="small" wrap>
                    <span>作者: {post.author}</span>
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </Space>
                }
              >
                <Space size="small" wrap>
                  {post.tags.map((tag, index) => (
                    <Tag key={index} color="blue">{tag}</Tag>
                  ))}
                </Space>
              </List.Item.Meta>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default ArchivePage;